import Papa from 'papaparse';

import { CellValue, ParsedFile, ParseIssue } from '../types';

import { buildSearchIndex } from './buildSearchIndex';
import { ROW_CAP } from './limits';

export function parseCsv(text: string, totalBytes: number | null): ParsedFile {
  const result = Papa.parse<Record<string, CellValue>>(text, {
    header: true,
    skipEmptyLines: 'greedy',
  });

  const headers = result.meta.fields ?? [];
  let rows = result.data;

  const truncated = rows.length > ROW_CAP;
  if (truncated) {
    rows = rows.slice(0, ROW_CAP);
  }

  const errors: ParseIssue[] = result.errors.map(err => ({
    rowIndex: err.row ?? null,
    message: err.message,
  }));

  const searchIndex = buildSearchIndex(rows, headers);

  return {
    headers,
    rows,
    searchIndex,
    truncated,
    totalBytes,
    errors,
  };
}
